import React from 'react';
import { useLoading } from 'ra-core';

const GlobalLoadingOverlay = () => {
    const loading = useLoading();
    if (!loading) return null;

    return (
        <div style={{
            position: 'fixed',
            inset: 0,
            zIndex: 99999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 14,
            background: 'rgba(255,255,255,0.82)',
            fontFamily: 'Arial, sans-serif',
            color: '#111'
        }}>
            <div style={{ fontSize: 28 }}>⏳</div>
            <div style={{ fontSize: 14 }}>Chargement de l’admin…</div>
        </div>
    );
};

export default GlobalLoadingOverlay;
